import { FC, ReactNode } from "react";
import parse from "html-react-parser";
import { commonHtmlParserOptions } from "@utils/html-parser";
import { ProgramSubCategory } from "@types";
import ProgramBook from "@svg/program-book";
import classNames from "classnames";
import { IconButton } from "@shared/components/icon-button";
import { IconChevronDown } from "@svg/chevron-down";
import { ICON_SIZE } from "@shared/components/icon-button/types";
import ControlledAccordion from "legacy/stories/Accordion/Controlled";

interface props {
  content: ProgramSubCategory;
  isOpen: boolean;
  onClickAccordion: () => void;
  children?: ReactNode;
}
const ProgramItem: FC<props> = ({
  content,
  children,
  isOpen,
  onClickAccordion,
}) => {
  return (
    <div
      className="bg-fds-canvas-primary p-3  md:px-5    md:py-3.5   flex flex-col gap-2  rounded-12 border border-fds-cart scroll-mt-24"
      id={`${content.id}-programs`}
    >
      <ControlledAccordion
        key={content.id}
        className={() => "transition-height h-10 mb-2"}
        title={
          <div className="flex items-center gap-1">
            <ProgramBook className="text-fds-on-brand-light-select pl-1 w-4 md:w-6" />
            <h3 className="text-xs font-semibold md:headline-sm text-fds-on-brand-light-select">
              {content.title}
            </h3>
          </div>
        }
        iconComponent={(isOpen) => (
          <IconButton
            size={ICON_SIZE.MEDIUM}
            className={classNames(
              "text-fds-icon-secondary transition-transform",
              isOpen ? "rotate-180" : "rotate-0"
            )}
            hideTooltip
            iconClassName="w-4 md:w-5"
            icon={<IconChevronDown />}
            aria-label="باز و بستن محتوا"
          />
        )}
        isOpen={isOpen}
        onClick={onClickAccordion}
      >
        <div className="w-full flex flex-col gap-2  ">
          {content.content &&
            parse(content.content || "", commonHtmlParserOptions())}
          {children}
        </div>
      </ControlledAccordion>
    </div>
  );
};

export default ProgramItem;
